module.exports = __webpack_public_path__ + "img/qgyj32-0.asm.63df5c1b.jpg";